module.exports = __webpack_public_path__ + "7e8e261a2f18b857d06f3c362f133d0d.jpg";